// Kleiner, wiederverwendbarer Hinweis für fehlgeschlagene Datenabrufe. Ohne ihn sieht
// „keine Daten vorhanden" auf dem Tablet im Keller identisch aus wie „Funkloch, Abruf
// fehlgeschlagen" — beides rendert sonst stillschweigend eine leere Liste. Token-Stil
// (design_handoff_uebergabe).
import React from 'react';
import { ArrowsClockwise, WarningCircle } from '@phosphor-icons/react';

interface LadeHinweisProps {
  text?: string;
  aufErneutVersuchen: () => void;
}

const LadeHinweis: React.FC<LadeHinweisProps> = ({
  text = 'Daten konnten nicht geladen werden — Verbindung prüfen.',
  aufErneutVersuchen,
}) => (
  <div role="alert" className="flex flex-wrap items-center justify-between" style={{ gap: 10, padding: '10px 12px 10px 14px', borderRadius: 16, background: 'var(--bad-soft)' }}>
    <span className="flex min-w-0 items-center" style={{ gap: 8, fontSize: 13, fontWeight: 700, color: 'var(--bad)' }}>
      <WarningCircle size={16} weight="fill" className="shrink-0" />
      {text}
    </span>
    <button type="button" onClick={aufErneutVersuchen} className="inline-flex shrink-0 items-center"
      style={{ height: 44, padding: '0 14px', gap: 6, borderRadius: 13, border: 'none', cursor: 'pointer', fontFamily: 'inherit', fontSize: 13, fontWeight: 800,
        background: 'var(--bg)', color: 'var(--ink)' }}>
      <ArrowsClockwise size={13} weight="bold" /> Erneut versuchen
    </button>
  </div>
);

export default LadeHinweis;
